export const QUOTATION_STATUS = {
  AC: 'Aceite',
  AN: 'Em análise',
  EX: 'Expirada',
  MI: 'Mais informação',
  RJ: 'Rejeitada',
} as const

export const QUOTATION_STATUS_CODE = {
  AC: 'AC',
  AN: 'AN',
  EX: 'EX',
  MI: 'MI',
  RJ: 'RJ',
} as const
